enum BrandType {

    TradeApp = "TradeApp",
    Financika = "Financika",
    FXGMZA = "FXGM-za",
    UBanker = "UBanker",
    SeventyTrades = "_70Trades",
    A3Trading = "A3Trading",
    TaoTrade = "TaoTrade",
    FXGM = "FXGM",
    GTCM = "GTCM",
    Fortissio = "Fortissio",
    Ontega = "Ontega",
    ForexCT = "ForexCT",
    TradoCenter = "TradoCenter",
    XLNTrade = "XLNTrade",
    WBSmith = "WBSmith",
    ToroInvest = "ToroInvest",
    Finansero = "Finansero",
    Profit = "Profit",
}

namespace BrandType {

    export function deserialize(type: string): BrandType {
        if (type === "70Trades") {
            return BrandType.SeventyTrades;
        } else if (type === "FXGM-za") {
            return BrandType.FXGMZA;
        } else if (type === "Warren Bowie & Smith") {
            return BrandType.WBSmith;
        }
        return BrandType[type] || type;
    }

    export function from(brand: string): BrandType {
        if (brand) {
            switch (brand) {
                case "fortissio":
                    return BrandType.Fortissio;
                case "fxgm":
                    return BrandType.FXGM;
                case "70trades":
                    return BrandType.SeventyTrades;
                case "a3trading":
                    return BrandType.A3Trading;
                case "financika":
                    return BrandType.Financika;
                case "forexct":
                    return BrandType.ForexCT;
                case "fxgmza":
                    return BrandType.FXGMZA;
                case "gtcm":
                    return BrandType.GTCM;
                case "ontega":
                    return BrandType.Ontega;
                case "taotrade":
                    return BrandType.TaoTrade;
                case "tradeapp":
                    return BrandType.TradeApp;
                case "tradocenter":
                    return BrandType.TradoCenter;
                case "ubanker":
                    return BrandType.UBanker;
                case "xlntrade":
                    return BrandType.XLNTrade;
                case "wbandsmith":
                    return BrandType.WBSmith;
                case "toroinvest":
                    return BrandType.ToroInvest;
                case "finansero":
                    return BrandType.Finansero;
                case "pro-fit":
                    return BrandType.Profit;
            }
        }
        return null;
    }

    export function folder(brandId: number): string {
        if (brandId) {
            switch (brandId) {
                case 41:
                    return "fortissio";
                case 7:
                    return "fxgm";
                case 39:
                    return "70trades";
                case 33:
                    return "a3trading";
                case 29:
                    return "financika";
                case 2:
                    return "forexct";
                case 56:
                    return "fxgmza";
                case 23:
                    return "gtcm";
                case 60:
                    return "ontega";
                case 34:
                    return "taotrade";
                case 61:
                    return "tradeapp";
                case 62:
                    return "tradocenter";
                case 35:
                    return "ubanker";
                case 40:
                    return "xlntrade";
                case 63:
                    return "wbandsmith";
                case 64:
                    return "toroinvest";
                case 65:
                    return "finansero";
                case 66:
                    return "pro-fit";
            }
        }
        return null;
    }
}

export {BrandType};
